import { config } from '@config'
import { HttpService } from '@services/HttpService'
import OrderDataService from './OrderDataService'
import { PRODUCT_SERVICE_ENDPOINTS } from '@modules/showroom/productCollection/enhancedView/constants/cnf-product-constants'

export default class InitialAllocationListDataService extends OrderDataService {
  httpService = new HttpService()

  // Products
  fetchIAProducts = (bsgId, clientOrderId, deliveryId, body) => {
    const orderPath = `/clientOrder/${clientOrderId}/delivery/${deliveryId}/products`

    const url = `${config.buyingBoardServiceRestEndpoint}${PRODUCT_SERVICE_ENDPOINTS.ENHANCED_PRODUCT_COMMON_PATH}/${bsgId}${orderPath}`

    return this.httpService
      .post(url, body, {
        ...this.getOptionsHeader()
      })
      .then(response => response?.data)
  }

  updateIAProductQuantity = (
    buyingSessionGroupId: string,
    productId: string,
    orderId: string,
    deliverySequence: Number,
    payload: any
  ) => {
    const url = `${config.buyingBoardServiceRestEndpoint}${PRODUCT_SERVICE_ENDPOINTS.ENHANCED_PRODUCT_COMMON_PATH}/${buyingSessionGroupId}/clientOrder/${orderId}/buyingSessionProduct/${productId}/delivery/${deliverySequence}/deliveryProductQuantity`
    return this.httpService
      .patch(url, payload, {
        ...this.getOptionsHeader()
      })
      .then(resp => resp?.data?.data)
      .catch(e => {
        console.error(e)
      })
  }

  rollUpIAProductQuantity = (
    buyingSessionGroupId: string,
    productId: string,
    orderId: string,
    deliverySequence: Number,
    payload: any
  ) => {
    const url = `${config.buyingBoardServiceRestEndpoint}${PRODUCT_SERVICE_ENDPOINTS.ENHANCED_PRODUCT_COMMON_PATH}/${buyingSessionGroupId}/clientOrder/${orderId}/buyingSessionProduct/${productId}/delivery/${deliverySequence}/rollUp`
    return this.httpService
      .patch(url, payload, {
        ...this.getOptionsHeader()
      })
      .then(resp => resp?.data?.data)
      .catch(e => {
        console.error(e)
      })
  }

  updateDeliveryAllocatedProductQuantity = (
    buyingSessionGroupId: string,
    bspId: string,
    orderId: string,
    deliverySequence: number,
    payload: any
  ) => {
    const url = `${config.buyingBoardServiceRestEndpoint}${PRODUCT_SERVICE_ENDPOINTS.ENHANCED_PRODUCT_COMMON_PATH}/${buyingSessionGroupId}/clientOrder/${orderId}/buyingSessionProduct/${bspId}/delivery/${deliverySequence}/deliveryAllocatedProductQuantity`
    return this.httpService
      .patch(url, payload, {
        ...this.getOptionsHeader()
      })
      .then(resp => resp?.data?.data)
      .catch(e => {
        console.error(e)
      })
  }

  updateDoorLevelTotalQuantity = (
    buyingSessionGroupId: string,
    productId: string,
    clientOrderId: string,
    doorOrderId: string = '',
    deliverySequence: string | number,
    payload
  ) => {
    const url = `${config.buyingBoardServiceRestEndpoint}${PRODUCT_SERVICE_ENDPOINTS.ENHANCED_PRODUCT_COMMON_PATH}/${buyingSessionGroupId}/clientOrder/${clientOrderId}/doorOrder/${doorOrderId}/buyingSessionProduct/${productId}/delivery/${deliverySequence}`
    return this.httpService
      .patch(url, payload, {
        ...this.getOptionsHeader()
      })
      .then(resp => resp?.data?.data)
      .catch(e => {
        console.error(e)
      })
  }

  updateIASizeQuantity = (
    buyingSessionGroupId: string,
    productId: string,
    clientOrderId: string,
    doorOrderId: string,
    payload: any,
    sizeId: string,
    deliverySequence
  ) => {
    const url = `${config.buyingBoardServiceRestEndpoint}${PRODUCT_SERVICE_ENDPOINTS.ENHANCED_PRODUCT_COMMON_PATH}/${buyingSessionGroupId}/clientOrder/${clientOrderId}/doorOrder/${doorOrderId}/buyingSessionProduct/${productId}/delivery/${deliverySequence}/size/${sizeId}`
    return this.httpService
      .patch(url, payload, {
        ...this.getOptionsHeader()
      })
      .then(resp => resp?.data?.data)
      .catch(e => {
        console.error(e)
      })
  }

  bulkUpdateDeliveryDoorOrderProducts = (
    buyingSessionGroupId: string,
    clientOrderId,
    bspId,
    deliverySequence,
    payload
  ) => {
    const url = `${config.buyingBoardServiceRestEndpoint}${PRODUCT_SERVICE_ENDPOINTS.ENHANCED_PRODUCT_COMMON_PATH}/${buyingSessionGroupId}/clientOrder/${clientOrderId}/buyingSessionProduct/${bspId}/delivery/${deliverySequence}/bulk`
    return this.httpService
      .patch(url, payload, {
        ...this.getOptionsHeader()
      })
      .then(resp => resp?.data?.data)
      .catch(e => {
        console.error(e)
      })
  }
}
